module.exports = __webpack_public_path__ + "static/img/flash-main.94dd0e5.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flash-main.webp
// module id = Ypgi
// module chunks = 13